import { AxiosRequestConfig } from 'axios';

import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';
import { setUFOInteractionErrorCheck } from 'util/ufoUtils';

import { baseLicenseApiUrl } from '../..';
import { getImpersonationHeader } from '../../helpers';

export const getFromHamsClient = async (
  remainingPath: string,
  state: State,
  ufoName: string,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.get(`${baseLicenseApiUrl}${remainingPath}`, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    setUFOInteractionErrorCheck(ufoName);
    return Promise.reject(error);
  }
};
